export const NAME = 'pressureSealElements';
